import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  alert: {
    width: '100%',
    marginRight: '2%',
    alignItems: 'center',
    marginBottom: '2%',

  },
  root: {
    padding: '4%',
    '& > *': {
      marginBottom: '1%',
      width: '100%',
      display: 'flex',
      flexDeriction: 'column'
    },

  },
  contactBtn: {
    background: 'orange',
    color: 'white',
    width: '35%',
    margin: '4%',
    borderRadius: '25px',
    '&:hover': {
      backgroundColor: '#FFC500',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '4% auto',
    },

  },
  homeContainer: {
    height: '600px',
    paddingRight: '2%',
    textAlign: 'center',
  },
  content: {
    position: 'relative',
    top: '35%',
    padding: "4%", 
    height: "30%",
    zIndex: 111,
    textAlign: 'center',
    verticalAlign: 'middle',
    alignContent: 'center',
  }
}));